var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAiFillNew = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38951 2V8.85715H1.96094V7.71429H2.53237C5.68828 7.71429 8.24665 5.15591 8.24665 2H9.38951Z",
    fill: "url(#paint0_linear_2959_44304)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24665 2V8.85715H15.6752V7.71429H15.1038C11.9479 7.71429 9.38951 5.15591 9.38951 2H8.24665Z",
    fill: "url(#paint1_linear_2959_44304)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38951 14.5714V7.71429H1.96094V8.85715H2.53237C5.68828 8.85715 8.24665 11.4155 8.24665 14.5714H9.38951Z",
    fill: "url(#paint2_linear_2959_44304)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24665 14.5714V7.71429H15.6752V8.85715H15.1038C11.9479 8.85715 9.38951 11.4155 9.38951 14.5714H8.24665Z",
    fill: "url(#paint3_linear_2959_44304)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1557 11.1429V14.8831H11.1038V14.2597H11.4155C13.1369 14.2597 14.5324 12.8643 14.5324 11.1429H15.1557Z",
    fill: "url(#paint4_linear_2959_44304)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5324 11.1429V14.8831H18.5843V14.2597H18.2726C16.5512 14.2597 15.1557 12.8643 15.1557 11.1429H14.5324Z",
    fill: "url(#paint5_linear_2959_44304)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1557 18V14.2597L11.1038 14.2597V14.8831L11.4155 14.8831C13.1369 14.8831 14.5324 16.2786 14.5324 18H15.1557Z",
    fill: "url(#paint6_linear_2959_44304)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5324 18V14.2597L18.5843 14.2597V14.8831L18.2726 14.8831C16.5512 14.8831 15.1557 16.2786 15.1557 18H14.5324Z",
    fill: "url(#paint7_linear_2959_44304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2959_44304",
    x1: 1.96094,
    y1: 10,
    x2: 18.5843,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979844,
    stopColor: "#099874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2959_44304",
    x1: 1.96094,
    y1: 10,
    x2: 18.5843,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979844,
    stopColor: "#099874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2959_44304",
    x1: 1.96094,
    y1: 10,
    x2: 18.5843,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979844,
    stopColor: "#099874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2959_44304",
    x1: 1.96094,
    y1: 10,
    x2: 18.5843,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979844,
    stopColor: "#099874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2959_44304",
    x1: 1.96094,
    y1: 10,
    x2: 18.5843,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979844,
    stopColor: "#099874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2959_44304",
    x1: 1.96094,
    y1: 10,
    x2: 18.5843,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979844,
    stopColor: "#099874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2959_44304",
    x1: 1.96094,
    y1: 10,
    x2: 18.5843,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979844,
    stopColor: "#099874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2959_44304",
    x1: 1.96094,
    y1: 10,
    x2: 18.5843,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979844,
    stopColor: "#099874"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAiFillNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai-fill-new.5c0150c53201f6d23ee4e99f30e73849.svg";